var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Items: "+_vm._s(_vm.data.items)+" "),_c('br'),_vm._v(" $"+_vm._s((_vm.data.total/100).toFixed(2))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }